<template>
  <div class="page-vue-embed">
    <div class="roi-wrapper">
      <v-app>
        <v-main>
          <div class="roi-dehn-bgcolor__light">
            <v-container class="roi-container__outer">
              <configurator-title></configurator-title>
              <v-alert
                v-if="this.$store.getters.errors[0]"
                border="right"
                colored-border
                type="error"
                elevation="2"
              >
                Entschuldigung: Es ist ein Fehler aufgetreten. Laden Sie die Seite neu oder versuchen Sie es später noch einmal.
              </v-alert>


              <div class="d-flex flex-column justify-center align-center"
                   v-if="this.$store.state.loadingStatus"
              >
                <v-progress-circular
                  :size="50"
                  color="primary"
                  indeterminate
                ></v-progress-circular>
                <div class="mt-4">loading</div>
              </div>

              <stepper
                v-if="!this.$store.state.loadingStatus"
              ></stepper>


            </v-container>
          </div>
        </v-main>
      </v-app>

    </div>
  </div>
</template>

<script>
import ConfiguratorTitle from './components/ConfiguratorTitle.vue'
import Stepper from "./components/Stepper";

export default {
  name: 'App',

  components: {
    ConfiguratorTitle,
    Stepper
  },

  data: () => ({
    instanceId: ''
  }),

  computed: {
  },

  created() {
    let lang = document.getElementsByTagName('html')[0].getAttribute('lang')
    this.$store.commit('SET_LANG', lang);
    this.$i18n.locale = this.$store.getters.lang;
    this.$store.dispatch('setInitialData');

  },
  beforeMount () {
    // Get the ID tag containing the roiupal instance id.
    this.instanceId = this.$parent.$el.id;
    let userRoles = document.getElementsByTagName('body')[0].getAttribute('class').match(/user-has-role-[^\s]+/g);
    this.$store.commit('SET_USER_ROLES', userRoles.map(function(x){return x.replace('user-has-role-','');}));
  },

  watch: {

  }
};
</script>

<style lang="scss">

@font-face {
  font-family: AvenirNext-DemiBold;
  src: url(./fonts/6afe4676-059a-4aa8-b891-29856bbcba22.woff2) format("woff2"),
  url(./fonts/a9817c16-2a79-49bf-8543-6c846d73a52f.woff) format("woff");
}
@font-face {
  font-family: AvenirNext-Medium;
  src: url(./fonts/f5d4f93b-454a-43e0-9ae8-7f1271b5c0fd.woff2) format("woff2"),
  url(./fonts/72556e8c-c677-48d8-81ff-3eb8fc50033b.woff) format("woff");
}

@import '../src/sass/variables.scss';
h1 {
  color: $c-dehn-gray--darkest;
}

.roi-wrapper {
  b, strong {
    font-family: AvenirNext-DemiBold, sans-serif;
    font-weight: normal;
  }
}


.theme--light.v-application {
  background: $c-dehn-gray--lighter !important;
}

.roi-dehn-bgcolor__light {
  background: $c-dehn-gray--lightest;
}

.dehn-bgcolor__light {
  background: $c-dehn-gray--lighter;
}

.dehn-bgcolor__white {
  background: $c-dehn-white;
}

.dehn-bgcolor__dark {
  background: $c-dehn-gray--darkest;
}

.dehn-bgcolor__red {
  background: $c-dehn-red;
}

.roi-container__outer {
  padding: 0 $container-padding-x-small;
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .roi-container__outer {
    padding: 0 $container-padding-x-medium 48px $container-padding-x-medium;
  }
}

@media #{map-get($display-breakpoints, 'md-and-up')} {
  .roi-container__outer {
    padding: 48px $container-padding-x-medium;
  }
}

@media #{map-get($display-breakpoints, 'lg-and-up')} {
  .roi-container__outer {
    padding: 48px $container-padding-x-large;
  }
}

.theme--light.v-stepper {
  background: $c-dehn-gray--lightest !important;
}

.theme--light.v-divider {
  border-color: $c-dehn-gray;
}

.dehn-v-stepper .v-stepper__content { transition: none; }

.v-stepper--alt-labels .v-stepper__label {
  text-align: center;
}

.dehn-v-stepper .v-stepper__step:first-child {
  //padding-left: 0;
}

.dehn-v-stepper .v-stepper__step:last-child {
  //padding-right: 0;
}

.dehn-vform {
  h3 {
    color: $c-dehn-text;
  }
}

.dehn-vform .v-label {
  font-size: 14px;
  font-family: AvenirNext-DemiBold, sans-serif;
}

.v-card--disabled > :not(.v-card__progress) {
  opacity: 0.3;
}

.roi-card {
  padding: 0 0;
}

.roi-card-transparent {
  background: none !important;
  .v-alert {
    margin-top: 16px;
  }
}

@media #{map-get($display-breakpoints, 'xs-only')} {
  .roi-card  {
    box-shadow: 10px 0 0 0 rgb(255, 255, 255), -10px 0 0 0 rgb(255, 255, 255)  !important;
  }
}

@media #{map-get($display-breakpoints, 'sm-and-up')} {
  .roi-card {
    padding: 10px;
  }
}

</style>
